import { Button } from "@mui/material";
import { API } from "aws-amplify";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FilterSelect from "../../components/FilterSelect";
import Recipe from "../../components/Recipe";
import RecipePreview from "../../components/RecipePreview";
import SearchBar from "../../components/SearchBar";
import SelectedRecepie from "../../components/SelectedRecipe";
import {
  SELECT_RECIPE,
  SET_RECIPES,
  UNSELECT_RECIPE,
} from "../../constants/reducerEvents";

export default function Home() {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const [filters, setFilters] = useState([]);

  const navigate = useNavigate();
  const recipes = useSelector((state) =>
    state.recipes.map((r, i) => ({ ...r, id: i }))
  );
  // const [selectedRecipies, setSelectedRecipies] = useState([]);
  const selectedRecipies = useSelector((state) =>
    state.shopping.selected.map((r) => r.recipe)
  );
  const filteredRecipes = recipes.filter(
    (r) =>
      filters.length === 0 ||
      (r.hasOwnProperty("meal") && filters.some((f) => r.meal.includes(f)))
  );
  const searchedRecipes = filteredRecipes.filter(
    (r) =>
      r.name.toLowerCase().includes(searchText.toLowerCase()) &&
      !selectedRecipies.some((re) => re.url === r.url)
  );
  const relatedRecipes = filteredRecipes.filter(
    (r) =>
      !selectedRecipies.some((re) => re.url === r.url) &&
      !r.name.toLowerCase().includes(searchText.toLowerCase()) &&
      r.keywords &&
      r.keywords.some((k) => k.toLowerCase().includes(searchText.toLowerCase()))
  );

  const clickRecipe = (r) => {
    navigate(`/recipe/${r.id}`);
  };
  const addRecipe = (r) => {
    dispatch({ type: SELECT_RECIPE, payload: r });
    // setSelectedRecipies((rec) => [...rec, r]);
  };
  const removeRecipe = (r) => {
    dispatch({ type: UNSELECT_RECIPE, payload: r });
    // setSelectedRecipies((rec) => rec.filter((re) => re.url != r.url));
  };
  const refreshRecipies = async () => {
    const data = await API.get("GeneralEndpoint", "/");
    console.log(data);
    if (data.hasOwnProperty("recipes")) {
      dispatch({
        type: SET_RECIPES,
        payload: data.recipes.map((r, i) => ({ ...r, id: i })),
      });
    }
  };
  return (
    <div>
      <div style={{ display: "flex", overflow: "scroll" }}>
        {selectedRecipies.map((r) => (
          <SelectedRecepie
            key={r.url}
            recipe={r}
            onClick={() => clickRecipe(r)}
            removeRecipe={() => removeRecipe(r)}
          />
        ))}
      </div>
      <div style={{ display: "flex" }}>
        <SearchBar text={searchText} setText={setSearchText} />
        <FilterSelect filters={filters} setFilters={setFilters} />
        <div style={{ display: "flex", marginLeft: "auto" }}>
          <div>
            <Button onClick={refreshRecipies}>Reload List</Button>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {searchedRecipes.map((r) => (
          <RecipePreview
            key={r.url}
            recipe={r}
            onClick={() => clickRecipe(r)}
            addRecipe={() => addRecipe(r)}
          />
        ))}
      </div>
      {relatedRecipes.length > 0 && (
        <div style={{ paddingLeft: "10px", fontSize: "20px" }}>
          Related Results
        </div>
      )}
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {relatedRecipes.map((r) => (
          <RecipePreview
            key={r.url}
            recipe={r}
            onClick={() => clickRecipe(r)}
            addRecipe={() => addRecipe(r)}
          />
        ))}
      </div>
    </div>
  );
}
